export default "__VITE_ASSET__D0aYxksw__"